import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import FinanceLayout from 'src/feature/finance/FinanceLayout'
import Ins1 from './assets/ins1.png'
import Ins2 from './assets/ins2.png'
import {BreadCrumb} from 'src/_metronic/layout/components'
import MCLogo from '../../_metronic/assets/mc-logo.svg'

const providers = [
  {
    name: 'AlphaCover',
    badge: 'Alpha Essential',
    coverages: ['General Liability', 'Professional Liability (E&O)', 'Cyber Insurance'],
    fit: 'Small retailers, cafés, local shops, and service businesses looking for essential business protection.',
    price: 45,
    img: Ins1,
    discount: '15',
  },
  {
    name: 'Alpha Growth',
    badge: 'Best Global Reach',
    coverages: ['Commercial Auto', 'Inland Marine', 'Crime & Fidelity'],
    fit: 'Growing retailers, franchise operators, delivery-based businesses, and multi-location merchants.',
    price: 82,
    img: Ins1,
    discount: '15',
  },
  {
    name: 'DemoShield',
    badge: 'Shield Business',
    coverages: ["Business Owner's Policy", "Workers' Compensation", 'Property Insurance'],
    fit: 'Established retailers, restaurants, convenience stores, and businesses with physical storefronts.',
    price: 68,
    img: Ins2,
    discount: '20',
  },

  {
    name: 'Shield Premium',
    badge: 'Premium Coverage',
    coverages: ['Executive Protection', 'High-Limit Property', 'International Coverage'],
    fit: ' High-revenue retailers, regional chains, wholesale businesses, and companies expanding into new markets.',
    price: 115,
    img: Ins2,
    discount: '25',
  },
]

export default function BusinessInsurancePage() {
  const navigate = useNavigate()
  const [isSuccess, setIsSuccess] = useState(false)
  const [selectedProvider, setSelectedProvider] = useState<typeof providers[0] | null>(null)

  if (isSuccess && selectedProvider) {
    return (
      <>
        <div className='d-flex mt-10'>
          <div className='card border border-gray-200 shadow-sm w-100'>
            <div className='card-body p-8 p-lg-15 text-center'>
              <div className='w-100px h-100px rounded-circle bg-light-success d-inline-flex align-items-center justify-content-center mb-5'>
                <i className='bi bi-check-circle-fill text-success fs-1' />
              </div>
              <h2 className='fw-bold text-gray-900 mb-3 fs-1'>Quote request submitted</h2>
              <p className='fs-5 mb-10 fw-bold'>
                Your insurance quote request has been sent and is being processed.
              </p>

              <div className='row g-4 text-start mb-10 w-75 mx-auto'>
                <div className='col-md-4 d-flex align-items-center'>
                  <div className='rounded bg-light p-6 h-100 d-flex align-items-center'>
                    <img src={selectedProvider.img} width={100} className='w-100' />
                  </div>
                </div>

                <div className='col-md-4'>
                  <div className='rounded bg-light p-6 h-100'>
                    <div className='text-uppercase fw-bold fs-8 mb-2 text-secondary'>Product</div>
                    <div className='fw-bold fs-3 text-gray-900'>{selectedProvider.name}</div>
                    <div className='text-uppercase fw-bold fs-8 mb-2 text-secondary mt-8'>
                      Monthly Fee
                    </div>
                    <div className='fw-bold fs-3 text-gray-900'>${selectedProvider.price} / mo</div>
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className='rounded bg-light p-6 h-100 d-flex flex-column justify-content-center gap-3'>
                    <div className='text-uppercase fw-bold fs-8 mb-2 text-secondary'>Coverages</div>
                    {selectedProvider.coverages.map((coverage) => (
                      <div key={coverage} className='d-flex align-items-center gap-2 fs-3'>
                        <i className='bi bi-check-circle-fill text-success' />
                        <span>{coverage}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className='separator separator-dashed my-10 w-75 mx-auto' />

              <div className='text-start w-75 mx-auto mb-10'>
                <h3 className='fw-bold text-gray-900 mb-6'>What happens next</h3>
                <div className='d-flex flex-column gap-5'>
                  <div className='d-flex align-items-center gap-4'>
                    <div className='w-30px h-30px rounded-circle bg-primary d-flex align-items-center justify-content-center flex-shrink-0'>
                      <span className='text-white fw-bold fs-7'>1</span>
                    </div>
                    <p className='fs-6 mb-0'>
                      Our team will review your business profile and coverage requirements.
                    </p>
                  </div>
                  <div className='d-flex align-items-center gap-4'>
                    <div className='w-30px h-30px rounded-circle bg-primary d-flex align-items-center justify-content-center flex-shrink-0'>
                      <span className='text-white fw-bold fs-7'>2</span>
                    </div>
                    <p className='fs-6 mb-0'>
                      A licensed insurance advisor will contact you within 24 business hours to
                      discuss options.
                    </p>
                  </div>
                  <div className='d-flex align-items-center gap-4'>
                    <div className='w-30px h-30px rounded-circle bg-primary d-flex align-items-center justify-content-center flex-shrink-0'>
                      <span className='text-white fw-bold fs-7'>3</span>
                    </div>
                    <p className='fs-6 mb-0'>
                      Once a policy is selected, you can finalize the binding and payment through
                      our portal.
                    </p>
                  </div>
                </div>
              </div>

              <div className='d-flex flex-column flex-sm-row gap-4 justify-content-center mt-5'>
                <button className='btn btn-primary px-10' onClick={() => navigate('/finance')}>
                  Return to finance
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className='row g-6 mb-8'>
        <div className='d-flex gap-5 align-items-center'>
          <button
            className='btn btn-primary btn-sm btn-back'
            onClick={() => {
              navigate('/finance')
            }}
          >
            <i className='fa fa-arrow-left'></i>
          </button>
          <BreadCrumb currentPage='Insurance' />
        </div>
        <div className='col-xl-8'>
          <div className='card border border-gray-200 shadow-sm h-100'>
            <div className='card-body p-7 p-lg-8'>
              <h3 className='fw-bold text-gray-900 mb-3'>Coverage matrix</h3>
              <p className='mb-6'>
                Evaluate fit, coverages, and indicative pricing without leaving the authenticated
                workspace.
              </p>
              <div className='row g-6'>
                {providers.map((provider) => (
                  <div key={provider.name} className='col-md-6'>
                    <div className='rounded bg-light h-100 p-6 d-flex flex-column'>
                      <div className='p-5 rounded rounded mb-10 d-flex justify-content-center align-items-center'>
                        <img src={provider.img} width={100} className='w-50 rounded' />
                      </div>
                      <div className='d-flex justify-content-between align-items-start gap-3 mb-4'>
                        <div>
                          <h4 className=''>{provider.badge}</h4>
                        </div>
                        <div className='text-end'>
                          <div className='fw-bold fs-2 text-primary'>${provider.price}</div>
                          <span className=' fs-8'>per month</span>
                        </div>
                      </div>
                      <div>
                        <span className='fw-bold d-flex align-items-center gap-2'>
                          <img src={MCLogo} height={13} />
                          <span>
                            {' '}
                            Pay with your saved Mastercard and get {provider.discount}% off
                            instantly
                          </span>
                        </span>
                      </div>
                      <div className='d-flex flex-column gap-2 my-4'>
                        {provider.coverages.map((coverage) => (
                          <div key={coverage} className='d-flex align-items-center gap-2  fs-7'>
                            <i className='bi bi-check-circle-fill text-success' />
                            <span>{coverage}</span>
                          </div>
                        ))}
                      </div>
                      <div className='fs-7 mb-6 flex-grow-1'>
                        <b>Best for: </b>
                        {provider.fit}
                      </div>
                      <button
                        className='btn btn-primary'
                        style={{
                          width: '35%',
                        }}
                        onClick={() => {
                          setSelectedProvider(provider)
                          setIsSuccess(true)
                        }}
                      >
                        Get a Quote
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className='col-xl-4'>
          <div className='card border border-gray-200 shadow-sm mb-6'>
            <div className='card-body p-7'>
              <h3 className='fw-bold text-secondary mb-4'>Selection guide</h3>
              <div className='d-flex flex-column gap-4'>
                <div className=''>
                  <div className='fw-bold text-gray-900 mb-1'>Top-rated providers</div>
                  <div className=''>
                    Insurance options suited for small and mid-sized businesses across common
                    coverage needs.
                  </div>
                </div>
                <div className=''>
                  <div className='fw-bold text-gray-900 mb-1'>Quick comparison</div>
                  <div className=''>
                    Review common policy types and pricing before speaking with an advisor.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='card border border-gray-200 shadow-sm'>
            <div className='card-body p-7'>
              <h4 className='fw-bold text-secondary mb-3'>Need help choosing?</h4>
              <p className='mb-5'>
                Our licensed insurance advisors can review your business needs and help you choose
                the right coverage.
              </p>
              <a
                className='fd-inline-flex align-items-center gap-2 text-primary fw-bold fs-7 text-secondary'
                href='#'
              >
                Schedule a call
                <i className='bi bi-arrow-right ms-2 text-secondary'></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
